import React from "react";
import Swiper from "react-id-swiper";

export default (props) => <Swiper {...props} />;
